import React from 'react';
import { Link } from 'react-router-dom';

const scoreColor = (score) => {
  if (score >= 8) return '#dc3545';   // red — high impact
  if (score >= 5) return '#fd7e14';   // orange — medium
  return '#6c757d';                   // grey — low
};

const HomeLinks = ({ billsData }) => {
  return (
    <div className="row g-3">
      {billsData.map((bill) => (
        <div key={bill.bill_number} className="col-12 col-sm-6 col-lg-4">
          <Link
            to={`/${bill.bill_number}`}
            className='card h-100 p-2 text-start home-link'
            style={{textDecoration: 'none'}}
          >
            <div className="d-flex justify-content-between align-items-start mb-1">
              <h5 className="mb-0">{bill.bill_number}</h5>
              {bill.impactScore != null && (
                <span
                  className="badge rounded-pill"
                  style={{background: scoreColor(bill.impactScore), fontSize: '0.75rem'}}
                  title="Day-to-day impact score (1–10)"
                >
                  {bill.impactScore}/10
                </span>
              )}
            </div>
            <p className="mb-1 flex-grow-1">{bill.title}</p>
            <div className="d-flex justify-content-between align-items-center mt-1">
              <h6 className="mb-0 text-muted">{bill.sponsor}</h6>
              {bill.category && (
                <span className="bill-category-tag">{bill.category}</span>
              )}
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default HomeLinks;